<template>
	<header class="login-gate-header flex justify-center py-8">
		<NuxtImg
			v-if="appStore.siteLogo?.filename"
			:src="appStore.siteLogo.filename"
			:alt="appStore.siteLogo.alt || 'logo'"
			class="logo"
			loading="eager"
			:width="appStore.siteLogoDimensions?.width"
			:height="appStore.siteLogoDimensions?.height"
		/>
	</header>
</template>

<script setup lang="ts">
const appStore = useAppStore();
</script>
